import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: null,
  metamaskLoading: null,
  metamaskConnectLoading: false,
  isLoggedIn: false,
  metamaskLoggedIn: false,
  metamaskConnected: false,
  success: false,
  metamaskSuccess: false,
  metamaskConnectSuccess: false,
  signup: false,
  error: null,
  walletAddress: "",
  userId: "",
  openSignUp: false,
  openLogin: false,
  agentID: null,
  thirdPartyToken: "",
  thirdPartyLoading: false,
  thirdPartyRedirectUrl: ""
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    refreshLoginStart: (state, action) => {
      state.loading = true;
    },
    refreshMetamaskLoginStart: (state, action) => {
      state.metamaskLoading = true;
    },
    refreshMetamaskLoginSuccess: (state, action) => {
      state.loading = false;
      state.metamaskConnectLoading = false;
      state.metamaskLoading = false;
      state.metamaskLoggedIn = true;
      state.metamaskSuccess = true;
      state.walletAddress = action.payload.walletAddress;
    },
    refreshLoginSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.isLoggedIn = true;
      state.metamaskConnected = action.payload.walletAddress ?? false;
      state.userId = action.payload.id;
      state.walletAddress = action.payload.walletAddress;
    },
    refreshLoginFailure: (state, action) => {
      state.loading = false;
      state.metamaskLoading = false;
      state.metamaskConnectLoading = false;
      state.error = action.payload;
      state.isLoggedIn = false;
    },
    loginStart: (state, action) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.isLoggedIn = true;
      state.userId = action.payload;
    },
    loginFailure: (state, action) => {
      state.loading = false;
    },
    connectMetamaskStart: (state, action) => {
      state.metamaskConnectLoading = true;
    },
    connectMetamaskSuccess: (state, action) => {
      state.metamaskConnectLoading = false;
      state.metamaskConnectSuccess = true;
      state.metamaskConnected = true;
      if (action.payload?.walletAddress) {
        state.walletAddress = action.payload.walletAddress;
      }
    },
    connectMetamaskFailure: (state, action) => {
      state.metamaskConnectLoading = false;
      state.walletAddress = "";
      state.metamaskConnected = false;
    },
    signUpStart: (state, action) => {
      state.loading = true;
    },
    signUpSuccess: (state, action) => {
      state.loading = false;
      state.signup = true;
      state.success = true;
    },
    signUpFailure: (state, action) => {
      state.loading = false;
    },
    logoutStart: (state, action) => {
      state.loading = true;
    },
    logoutSuccess: (state, action) => {
      state.loading = false;
      state.metamaskLoading = false;
      state.success = true;
      state.isLoggedIn = false;
      state.metamaskConnected = false;
      state.metamaskLoggedIn = false;
      state.userId = "";
      state.walletAddress = "";
    },
    logoutFailure: (state, action) => {
      state.loading = false;
    },
    metamaskLoginStart: (state, action) => {
      state.metamaskLoading = true;
    },
    metamaskLoginSuccess: (state, action) => {
      state.metamaskLoading = false;
      state.walletAddress = action.payload;
      state.metamaskLoggedIn = true;
      state.metamaskSuccess = true;
    },
    metamaskLoginFailure: (state, action) => {
      state.metamaskLoading = false;
    },
    verifyEmailStart: (state, action) => {
      state.loading = true;
    },
    verifyEmailSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    verifyEmailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    forgotPasswordStart: (state, action) => {
      state.loading = true;
    },
    forgotPasswordSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    forgotPasswordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    verifyPasswordTokenStart: (state, action) => {
      state.loading = true;
    },
    verifyPasswordTokenSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    verifyPasswordTokenFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetSuccess: (state, action) => {
      state.success = false;
      state.signup = false;
      state.agentID = initialState.agentID;
    },
    resetError: (state, action) => {
      state.error = null;
    },
    handleOpenSignUpRedux: (state, action) => {
      state.openSignUp = !state.openSignUp;
    },
    handleOpenLoginRedux: (state, action) => {
      state.openLogin = !state.openLogin;
    },
    resetLoginRedux: (state, action) => {
      state.openLogin = false;
    },
    setAgentId: (state, action) => {
      state.agentID = action.payload;
    },
    resetAuthenticationState: () => initialState,

    sbUserInitilizeStart: (state, action) => {},
    sbUserInitilizeSuccess: (state, action) => {},
    sbUserInitilizeFailure: (state, action) => {},

    thirdPartyTokenLoginStart: (state, action) => {
      state.thirdPartyLoading = true;
    },
    thirdPartyTokenLoginSuccess: (state, action) => {
      state.thirdPartyLoading = false;
      state.thirdPartyRedirectUrl = action.payload;
    },
    thirdPartyTokenLoginFailure: (state, action) => {
      state.thirdPartyLoading = false;
    }
  }
});

export const {
  refreshLoginStart,
  refreshLoginSuccess,
  refreshLoginFailure,
  refreshMetamaskLoginStart,
  refreshMetamaskLoginSuccess,
  refreshMetamaskLoginFailure,
  loginStart,
  loginFailure,
  loginSuccess,
  signUpStart,
  signUpSuccess,
  signUpFailure,
  logoutStart,
  logoutSuccess,
  logoutFailure,
  verifyEmailStart,
  verifyEmailSuccess,
  verifyEmailFailure,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  verifyPasswordTokenStart,
  verifyPasswordTokenSuccess,
  verifyPasswordTokenFailure,
  metamaskLoginStart,
  metamaskLoginSuccess,
  metamaskLoginFailure,
  connectMetamaskStart,
  connectMetamaskSuccess,
  connectMetamaskFailure,
  resetError,
  resetSuccess,
  resetAuthenticationState,
  handleOpenSignUpRedux,
  handleOpenLoginRedux,
  setAgentId,
  sbUserInitilizeStart,
  sbUserInitilizeSuccess,
  sbUserInitilizeFailure,
  resetLoginRedux,
  thirdPartyTokenLoginStart,
  thirdPartyTokenLoginSuccess,
  thirdPartyTokenLoginFailure
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
